module.exports = __webpack_public_path__ + "img/banner_bg_mobile.e5ca78ef.jpg";